import * as React from "react";

import { cn } from "@/lib/utils/tw";
import { cva, type VariantProps } from "class-variance-authority";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
  icon?: React.ReactNode;
  rightButton?: React.ReactNode;
  inputClassName?: string;
  children?: React.ReactNode;
}

// Need variants

const inputVariants = cva("", {
  variants: {
    variant: {
      default:
        "border-input flex items-center overflow-hidden rounded-md border bg-card text-base shadow-sm hover:shadow-none",
      none: "text-base overflow-hidden flex items-center bg-card",
    },
    focus: {
      default:
        "ring-0 transition-all focus-within:border-neutral-400 focus-within:ring-2 focus-within:ring-neutral-500 focus-within:ring-opacity-30 hover:border-neutral-400",
      none: "",
    },
  },
  defaultVariants: {
    variant: "default",
    focus: "default",
  },
});

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      variant,
      focus,
      inputClassName,
      type,
      icon,
      rightButton,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={cn(inputVariants({ variant, focus, className }))}>
        {icon}
        <input
          {...props}
          type={type}
          ref={ref}
          data-1p-ignore
          className={cn(
            "w-full px-2 py-1 placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
            // "focus-within:ring-primary-500 focus-within:ring-2 focus-within:ring-opacity-50",

            inputClassName,
          )}
        />
        {children}
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
